// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".direction-container{margin-top:80px}.direction-container h2{margin-bottom:30px}.direction-container__list{display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));justify-items:center;gap:70px}@media screen and (max-width:767px){.direction-container__list{gap:20px}}", ""]);
// Exports
module.exports = exports;
